<template>
  <el-main class="rh-medtable">
    <h1>Thèses</h1>
    <app-table
      tablenom="medtheses"
      :cols="colonnes"
      :items="theses"
      :loadstatus="thesesLoadStatus"
      :deletestatus="theseDeleteStatus"
      :formroutes="thFormRoutes"
      :actions="thActions"
      :ismeddetail="true"
    >
    </app-table>
  </el-main>
</template>
<script>
import AppTable from "@/components/rh/ui/table/AppTable";

export default {
  components: { "app-table": AppTable },
  data() {
    return {
      idMed: this.$route.params.idmed, // récupère le id du médecin dans l'url
      thFormRoutes: {
        edit: {
          route: "med_theses_edit",
          params: { idmed: "id_med", idth: "id" },
        },
        create: {
          route: "med_theses_create",
          params: { idmed: this.$route.params.idmed },
        },
      },
    };
  },
  computed: {
    thesesLoadStatus() {
      // 1 = loading, 2 = succès, 3 = échec du chargement des données
      return this.$store.state.th.thesesLoadStatus;
    },
    theseDeleteStatus() {
      // 1 = deleting, 2 = succès, 3 = échec
      return this.$store.state.th.theseDeleteStatus;
    },
    theses() {
      // n'affiche que les theses du médecin sélectionné
      return this.$store.state.th.theses.filter((c) => c.id_med == this.idMed);
    },
    colonnes() {
      // n'affiche pas la colonne 'noms des médecins'
      return this.$store.state.th.colonnes.filter(
        (col) => col.prop != "medecin"
      );
    },
    thActions() {
      return this.$store.state.th.actions;
    },
  },
};
</script>
